<template>
    <el-date-picker
        :value="value"
        @change="(val) => $emit('input', val)"
        v-bind="$attrs"
        v-on="$listeners">
    </el-date-picker>
</template>

<script>
export default {
    props: {
        value: {
            default: null,
        },
    },
    computed: {},
    data () {
        return {};
    },
    mounted () {},
};
</script>

<style>

</style>
